export default "__VITE_ASSET__BFM7v3tH__"